module.exports = __webpack_public_path__ + "img/warehouseRequest.4537019b.png";